<form class="form">
  <div class="title" *ngIf="this.title">{{ title }}</div>
  <div class="subtitle" *ngIf="this.subtitle" [ngStyle]="getSubtitleWidth()">
    {{ this.subtitle }}
  </div>
  <div *ngIf="optionPipe != null">
    <mat-form-field appearance="outline">
      <mat-select
        matInput
        placeholder="Maak een keuze"
        name="answer"
        [(ngModel)]="answer"
        [compareWith]="compareWith"
        [disabled]="disabled"
        required
        (ngModelChange)="answered($event)"
      >
        <mat-option *ngFor="let option of options" [value]="option">
          {{ optionPipe.transform(optionValueGetter(option)) }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div *ngIf="optionPipe == null">
    <mat-form-field appearance="outline">
      <mat-select
        matInput
        placeholder="Maak een keuze"
        name="answer"
        [(ngModel)]="answer"
        [compareWith]="compareWith"
        [disabled]="disabled"
        required
        (ngModelChange)="answered($event)"
      >
        <mat-option *ngFor="let option of options" [value]="option">
          {{ optionValueGetter(option) }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</form>
